export async function registerSW() {
    if (!("serviceWorker" in navigator)) return null;
    try {
        const reg = await navigator.serviceWorker.register("/sw.js", { scope: "/" });

        reg.addEventListener("updatefound", () => {
            const nw = reg.installing;
            if (nw) {
                nw.addEventListener("statechange", () => {
                    if (nw.state === "installed") {
                        try { nw.postMessage({ type: "SKIP_WAITING" }); } catch {}
                    }
                });
            }
        });

        await navigator.serviceWorker.ready;
        return reg;
    } catch {
        return null;
    }
}

export async function readySW() {
    if (!("serviceWorker" in navigator)) return null;
    try { return await navigator.serviceWorker.ready; } catch { return null; }
}

// --- HARD RESET: open https://tvujweb.tld/?swreset=1 na iPhonu ---
(async () => {
    try {
        const usp = new URLSearchParams(window.location.search);
        if (!usp.has("swreset")) return;

        if ("serviceWorker" in navigator) {
            const regs = await navigator.serviceWorker.getRegistrations();
            for (const r of regs) { try { await r.unregister(); } catch {} }
        }

        if ("caches" in window) {
            const keys = await caches.keys();
            for (const k of keys) { try { await caches.delete(k); } catch {} }
        }

        try { localStorage.clear(); } catch {}
        try { sessionStorage.clear(); } catch {}

        // čistej reload bez query
        const cleanUrl = window.location.origin + window.location.pathname;
        window.location.replace(cleanUrl);
    } catch (e) {
        // když by něco spadlo, i tak udělej náhradní reload
        window.location.reload();
    }
})();
